// Masifi: solo es/en (decisión 2026-06-16). Ver config/initializers/masifi_languages.rb
// y docs/upgrade-runbook.md. Los demás locales se removieron para recortar el bundle
// y la superficie de conflicto de rebase del rebrand i18n.
import en from './locale/en';
import es from './locale/es';

export default {
  en,
  es,
};
